import React, { FC } from 'react';
import { SCUIGeneralModal } from '../../../../../atomic/molecules';
import { Grid, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const SCUIBillingAddToListModal: FC<{
    open: boolean;
    onClose: any;
    orderNo: string;
    setOrderNo: any;
    listele: any;
}> = ({ open, onClose, orderNo, setOrderNo, listele }) => {
    const { t } = useTranslation();

    return (
        <SCUIGeneralModal
            width={'xs'}
            open={open}
            onClose={onClose}
            title={t('general.batchSearch')}
            functionButtonOnClick={listele}
            buttonText={t('general.search')}
        >
            <Grid className="billing-query-add-to-list-modal" container sx={{ padding: '2rem' }}>
                <TextField
                    className="billing-query-add-to-list-modal-billing-nos"
                    sx={{ paddingBottom: '1rem' }}
                    label={'Fatura No'}
                    value={orderNo}
                    multiline
                    rows={10}
                    onChange={(event: any) => {
                        setOrderNo(event.target.value);
                    }}
                    slotProps={{ inputLabel: { shrink: true } }}
                    fullWidth
                />
            </Grid>
        </SCUIGeneralModal>
    );
};
